import axios from "axios";

import { API_BASE_URL } from '../config';


const getPlacesByProviderId = async (providerId) => {
  const url = `${API_BASE_URL}places?providerId=${providerId}`;

  try {
    const response = await axios.get(url);
    return response.data.data; // Return the data from the API response
  } catch (error) {
    console.error("Error fetching places by provider ID:", error);
    throw error;
  }
};

export default getPlacesByProviderId;
